<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { permissionManager } from "@/utils/permission";

/**
 * 管理员添加/编辑页面组件
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "添加管理员",
      items: [
        {
          text: "管理员",
          href: "/admin/list",
        },
        {
          text: "添加管理员",
          active: true,
        },
      ],

      // 设备检测
      ismobile: false,
      
      // 用户信息
      userinfo: [],
      
      // 管理员信息
      admininfo: {
        username: "",
        phone: "",
        country: 86,
        email: "",
        roleid: 3, // 权限组，默认只读
        avatar: ""
      },
      
      // 密码相关
      userpassword: "",
      reinputuserpassword: "",
      
      // 状态控制
      loading: true,
      adminid: 0,
      showsuccess: false,
      isEdit: false,
      
      // 选项列表
      countrylist: [],
      permissionLevels: [
        { value: 0, label: "超级管理员", description: "拥有所有权限" },
        { value: 1, label: "管理员", description: "拥有大部分权限" },
        { value: 2, label: "操作员", description: "拥有有限权限" },
        { value: 3, label: "只读用户", description: "只能查看数据" }
      ],
      
      // 表单验证
      formRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 4, max: 20, message: '用户名长度在 4 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: this.validatePhoneNumber, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        userpassword: [
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        reinputuserpassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' }
        ]
      }
    };
  },
  async mounted() {
    await this.$permissionManager.ensureReady();
    const needPerm = this.$route.query.id ? 'admin.edit' : 'admin.add';
    if (!this.$hasPermission(needPerm)) {
      this.$message.error(this.$t('global.text.missingPermission') || '权限不足');
      this.$router.replace({ name: '403 Forbidden' });
      return;
    }

    this.userinfo = JSON.parse(localStorage.getItem("user"));
    
    // 检测移动设备
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }

    // 检查是否为编辑模式
    if (this.$route.query.id) {
      this.adminid = this.$route.query.id;
      this.isEdit = true;
      this.title = this.$t("admin.edit.title");
    } else {
      this.loading = false;
      this.title = this.$t("admin.add.title");
    }

    // 更新面包屑
    this.updateBreadcrumb();
    
    // 初始化国家列表
    this.initCountryList();
    
    this.bootstrapRoleOptions();
  },
  methods: {
    async bootstrapRoleOptions() {
      await this.fetchRolesFromApi();
      this.initPermissionLevels();
      if (this.isEdit && this.adminid) {
        this.getAdminDetail();
      }
    },
    fetchRolesFromApi() {
      if (!this.userinfo.openid || !this.apiuri) {
        return Promise.resolve();
      }
      return this.$axios
        .post(
          this.apiuri,
          { action: "getroles" },
          { headers: { Openid: this.userinfo.openid } }
        )
        .then((res) => {
          if (res.data && res.data.status === 200 && res.data.data) {
            permissionManager.applyServerRoles(res.data.data);
          }
        })
        .catch(() => {});
    },
    // 更新面包屑导航
    updateBreadcrumb() {
      this.items = [
        {
          text: this.$t("menuitems.admin.text"),
          href: "/admin/list",
        },
        {
          text: this.isEdit ? this.$t("admin.edit.title") : this.$t("admin.add.title"),
          active: true,
        },
      ];
    },

    // 初始化国家列表
    initCountryList() {
      this.countrylist = [
        { value: 86, label: this.$t("global.country.china") },
        { value: 1, label: this.$t("global.country.usa") },
        { value: 81, label: this.$t("global.country.japan") },
        { value: 44, label: this.$t("global.country.uk") },
        { value: 34, label: this.$t("global.country.spain") },
        { value: 33, label: this.$t("global.country.french") },
        { value: 60, label: this.$t("global.country.malaysia") },
        { value: 65, label: this.$t("global.country.singapore") },
      ];
    },

    getCurrentUserLevel() {
      if (permissionManager.roleId != null) {
        return parseInt(permissionManager.roleId, 10);
      }
      try {
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        const rid = parseInt(
          user.roleid != null ? user.roleid : user.roleId,
          10
        );
        return Number.isFinite(rid) ? rid : 3;
      } catch (e) {
        return 3;
      }
    },

    roleLevelLabel(roleId) {
      const preset = {
        0: "permission.level.superAdmin",
        1: "permission.level.admin",
        2: "permission.level.operator",
        3: "permission.level.viewer",
        4: "permission.level.store",
      };
      const key = preset[roleId];
      return key ? this.$t(key) : "";
    },

    roleLevelDesc(roleId) {
      const preset = {
        0: "permission.level.superAdminDesc",
        1: "permission.level.adminDesc",
        2: "permission.level.operatorDesc",
        3: "permission.level.viewerDesc",
        4: "permission.level.storeDesc",
      };
      const key = preset[roleId];
      return key ? this.$t(key) : "";
    },

    canAssignRole(roleId, currentUserLevel) {
      const rid = parseInt(roleId, 10);
      if (rid === 4) {
        return currentUserLevel === 0;
      }
      if (currentUserLevel === 0) {
        return true;
      }
      if (currentUserLevel === 1) {
        return rid !== 0 && rid !== 1;
      }
      if (currentUserLevel === 2) {
        return rid === 3;
      }
      return false;
    },

    initPermissionLevels() {
      const currentUserLevel = this.getCurrentUserLevel();
      const allRoles = permissionManager.getAllRoles();

      this.permissionLevels = allRoles
        .filter((role) => this.canAssignRole(role.id, currentUserLevel))
        .map((role) => {
          const presetLabel = this.roleLevelLabel(role.id);
          const presetDesc = this.roleLevelDesc(role.id);
          return {
            value: role.id,
            label: role.name || presetLabel || String(role.id),
            description:
              role.description || presetDesc || role.name || String(role.id),
          };
        })
        .sort((a, b) => a.value - b.value);

      if (this.permissionLevels.length === 0) {
        this.$message.warning(
          this.$t("admin.add.noAssignableRole") || "您没有权限分配任何角色"
        );
      } else if (!this.isEdit) {
        const lowestLevel = Math.min(
          ...this.permissionLevels.map((level) => level.value)
        );
        const allowed = this.permissionLevels.some(
          (l) => l.value === this.admininfo.roleid
        );
        if (!allowed) {
          this.admininfo.roleid = lowestLevel;
        }
      }
    },

    // 获取管理员详情（编辑模式）
    getAdminDetail() {
      const that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getadminuserinfo",
            id: that.adminid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          const newdata = response.data.data;
          
          // 处理手机号：统一处理 +861 或 861 格式为 86
          let phoneNumber = newdata.phone || "";
          let countryCode = 86; // 默认中国
          let phone = "";
          
          console.log("=== 手机号解析调试 ===");
          console.log("原始手机号:", phoneNumber);
          console.log("手机号长度:", phoneNumber.length);
          
          if (phoneNumber.startsWith("+")) {
            console.log("处理带+号的手机号");
            // 特殊处理：+861 开头的统一处理为 +86
            if (phoneNumber.startsWith("+861")) {
              console.log("检测到+861格式，统一处理为+86");
              // 去掉+86，保留后面的11位手机号（+861中的1是手机号第一位）
              phone = phoneNumber.substring(3); // +86 -> 去掉3位
              countryCode = 86;
              console.log("✅ +861格式解析成功:", { countryCode, phone });
            } else if (phoneNumber.startsWith("+86") && phoneNumber.length === 14) {
              // 标准 +86 + 11位手机号
              countryCode = 86;
              phone = phoneNumber.substring(3);
              console.log("✅ 标准+86格式解析成功:", { countryCode, phone });
            } else {
              // 其他国家的手机号
              const match = phoneNumber.match(/^\+(\d{1,3})(\d{8,11})$/);
              if (match) {
                countryCode = parseInt(match[1]);
                phone = match[2];
                console.log("✅ 其他国家手机号解析成功:", { countryCode, phone });
              }
            }
          } else if (phoneNumber.length > 11) {
            console.log("处理无+号的手机号");
            // 特殊处理：861 开头的统一处理为 86
            if (phoneNumber.startsWith("861")) {
              console.log("检测到861格式，统一处理为86");
              // 去掉86，保留后面的11位手机号（861中的1是手机号第一位）
              phone = phoneNumber.substring(2); // 86 -> 去掉2位
              countryCode = 86;
              console.log("✅ 861格式解析成功:", { countryCode, phone });
            } else if (phoneNumber.startsWith("86") && phoneNumber.length === 13) {
              // 标准 86 + 11位手机号
              countryCode = 86;
              phone = phoneNumber.substring(2);
              console.log("✅ 标准86格式解析成功:", { countryCode, phone });
            }
          } else {
            console.log("处理11位手机号");
            phone = phoneNumber;
            console.log("✅ 11位手机号:", { countryCode, phone });
          }
          
          console.log("最终解析结果:", { countryCode, phone });
          console.log("=== 手机号解析结束 ===");
          
          // 检查编辑权限：不能编辑同级或高一级的用户
          const targetUserLevel =
            parseInt(newdata.effective_role_id, 10) ||
            parseInt(newdata.roleid, 10) ||
            parseInt(newdata.role_id, 10) ||
            1;
          const currentUserLevel = that.getCurrentUserLevel();

          if (currentUserLevel > 0 && targetUserLevel <= currentUserLevel) {
            that.$message.error(
              that.$t("admin.edit.noPermission") ||
                "您没有权限编辑同级或高一级的用户"
            );
            that.$router.go(-1);
            return;
          }

          that.admininfo = {
            username: newdata.username || "",
            phone: phone,
            country: countryCode,
            email: newdata.email || "",
            roleid: targetUserLevel,
            avatar: newdata.userimg || "",
          };

          const roleOk = that.permissionLevels.some(
            (l) => l.value === targetUserLevel
          );
          if (!roleOk) {
            that.initPermissionLevels();
          }
        })
        .catch(function (error) {
          that.loading = false;
          // console.log(error);
          that.$message.error(that.$t("global.error"));
        });
    },
    // 密码确认验证
    validatePassword(rule, value, callback) {
      if (value !== this.userpassword) {
        callback(new Error(this.$t("admin.add.passnotmarch")));
      } else {
        callback();
      }
    },

    // 添加/更新管理员
    saveAdmin() {
      // 权限检查：不能添加同级或高一级的用户
      const currentUserLevel = this.getCurrentUserLevel();
      const targetUserLevel = this.admininfo.roleid;
      
      if (currentUserLevel > 0 && targetUserLevel <= currentUserLevel) {
        this.$message.error('您没有权限添加同级或高一级的用户');
        return;
      }
      
      // 表单验证
      if (!this.validateForm()) {
        return;
      }

      const that = this;
      
      // 构建完整的手机号（国家代码+号码）
      const fullPhone = "+" + that.admininfo.country + that.admininfo.phone;
      
      const postdata = {
        action: that.isEdit ? "updateadmin" : "addnewadmin",
        id: that.adminid,
        phone: fullPhone,
        username: that.admininfo.username,
        email: that.admininfo.email,
        role_id: that.admininfo.roleid,
        roleid: that.admininfo.roleid,
        password: that.reinputuserpassword,
      };
      
      // 调试信息
      console.log("保存数据:", postdata);
      console.log("手机号处理:", {
        原始: that.admininfo.phone,
        国家代码: that.admininfo.country,
        完整手机号: fullPhone
      });

      // 如果是编辑模式且密码为空，则不更新密码
      if (that.isEdit && !that.userpassword) {
        delete postdata.password;
      }

      that.$axios
        .post(that.apiuri, postdata, {
          headers: { Openid: that.userinfo.openid },
        })
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.showsuccess = true;
            that.$message.success(
              that.isEdit ? that.$t("admin.edit.success") : that.$t("admin.add.success")
            );
          } else {
            if (response.data.msg) {
              that.$message.error(
                that.$t("admin.add.error." + response.data.msg)
              );
            } else {
              that.$message.error(that.$t("global.error"));
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          that.$message.error(that.$t("global.error"));
        });
    },

    // 表单验证
    validateForm() {
      if (!this.admininfo.username) {
        this.$message.error(this.$t("admin.add.usernotintut"));
        return false;
      }
      if (this.admininfo.username.length < 4) {
        this.$message.error(this.$t("admin.add.userlong"));
        return false;
      }
      if (!this.admininfo.phone) {
        this.$message.error(this.$t("admin.add.phonenotintut"));
        return false;
      }
      if (!this.validatePhoneNumber(this.admininfo.phone)) {
        this.$message.error(this.$t("admin.add.phonelong"));
        return false;
      }
      if (!this.isEdit && !this.userpassword) {
        this.$message.error(this.$t("admin.add.passwordnotinput"));
        return false;
      }
      if (this.userpassword && this.userpassword.length < 6) {
        this.$message.error(this.$t("admin.add.passwordlong"));
        return false;
      }
      if (this.userpassword && this.userpassword !== this.reinputuserpassword) {
        this.$message.error(this.$t("admin.add.passnotmarch"));
        return false;
      }
      return true;
    },
    // 获取权限级别标签类型
    getPermissionLevelTagType(topuid) {
      const types = {
        0: "danger",
        1: "primary",
        2: "warning",
        3: "info",
        4: "success",
      };
      return types[topuid] || "info";
    },

    // 格式化手机号显示
    formatPhoneDisplay(phoneNumber) {
      if (!phoneNumber) return "";
      
      // 处理 +861231231231 格式
      if (phoneNumber.startsWith("+")) {
        const match = phoneNumber.match(/^\+(\d{1,3})(\d+)$/);
        if (match) {
          return {
            country: parseInt(match[1]),
            phone: match[2]
          };
        }
      }
      
      // 处理 861231231231 格式（没有+号）
      if (phoneNumber.length === 13 && phoneNumber.startsWith("86")) {
        return {
          country: 86,
          phone: phoneNumber.substring(2)
        };
      }
      
      // 处理纯11位手机号
      if (phoneNumber.length === 11) {
        return {
          country: 86,
          phone: phoneNumber
        };
      }
      
      return {
        country: 86,
        phone: phoneNumber
      };
    },

    // 验证手机号格式
    validatePhoneNumber(phoneNumber) {
      if (!phoneNumber) return false;
      
      // 中国手机号验证：1[3-9]\d{9}
      const chinaPhoneRegex = /^1[3-9]\d{9}$/;
      return chinaPhoneRegex.test(phoneNumber);
    },

    // 获取权限级别图标
    getPermissionLevelIcon(topuid) {
      const icons = {
        0: "ri-shield-star-line",
        1: "ri-shield-user-line",
        2: "ri-user-settings-line",
        3: "ri-eye-line",
        4: "ri-store-2-line",
      };
      return icons[topuid] || "ri-shield-keyhole-line";
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="card-title mb-0">
                <i class="ri-user-add-line me-2"></i>
                {{ isEdit ? $t("admin.edit.title") : $t("admin.add.title") }}
              </h5>
              <div class="text-muted">
                <small>{{ isEdit ? $t("admin.edit.subtitle") : $t("admin.add.subtitle") }}</small>
              </div>
            </div>
          </div>
          
          <div class="card-body" v-loading="loading" v-if="!showsuccess">
            <el-form 
              ref="adminForm" 
              :model="admininfo" 
              label-width="120px"
              class="admin-form"
            >
              <!-- 基本信息 -->
              <div class="row mb-4">
                <div class="col-12">
                  <h6 class="text-primary mb-3">
                    <i class="ri-user-line me-2"></i>
                    {{ $t("admin.add.basicInfo") }}
                  </h6>
                </div>
              </div>

              <div class="row">
                <!-- 用户名 -->
                <div class="col-md-6 mb-3">
                  <el-form-item 
                    :label="$t('admin.add.username')" 
                    prop="username"
                    :rules="formRules.username"
                  >
                    <el-input
                      v-model="admininfo.username"
                      :placeholder="$t('admin.add.username')"
                      prefix-icon="ri-user-line"
                      :disabled="isEdit"
                      clearable
                    />
                    <small v-if="isEdit" class="text-muted">
                      {{ $t("admin.add.usernameEditTip") }}
                    </small>
                  </el-form-item>
                </div>

                <!-- 邮箱 -->
                <div class="col-md-6 mb-3">
                  <el-form-item 
                    :label="$t('admin.add.email')" 
                    prop="email"
                    :rules="formRules.email"
                  >
                    <el-input
                      v-model="admininfo.email"
                      :placeholder="$t('admin.add.email')"
                      prefix-icon="ri-mail-line"
                      clearable
                    />
                  </el-form-item>
                </div>

                <!-- 手机号码 -->
                <div class="col-md-6 mb-3">
                  <el-form-item 
                    :label="$t('admin.add.phone')" 
                    prop="phone"
                    :rules="formRules.phone"
                  >
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-select
                          v-model="admininfo.country"
                          :placeholder="$t('admin.add.selectcountry')"
                          filterable
                        >
                          <el-option
                            v-for="item in countrylist"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                            <span style="float: left">{{ item.label }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">
                              +{{ item.value }}
                            </span>
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="16">
                        <el-input
                          v-model="admininfo.phone"
                          :placeholder="$t('admin.add.phone')"
                          prefix-icon="ri-phone-line"
                          maxlength="11"
                          clearable
                        />
                      </el-col>
                    </el-row>
                  </el-form-item>
                </div>
              </div>

              <!-- 权限设置 -->
              <div class="row mb-4">
                <div class="col-12">
                  <h6 class="text-primary mb-3">
                    <i class="ri-shield-user-line me-2"></i>
                    {{ $t("admin.add.permissionSettings") }}
                  </h6>
                </div>
              </div>

              <div class="row">
                <!-- 权限级别 -->
                <div class="col-md-6 mb-3">
                  <el-form-item :label="$t('permission.level.title')">
                    <el-select
                      v-model="admininfo.roleid"
                      :placeholder="$t('admin.add.selectPermissionLevel')"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in permissionLevels"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <div class="d-flex justify-content-between align-items-center">
                          <span>{{ item.label }}</span>
                          <el-tag 
                            :type="getPermissionLevelTagType(item.value)" 
                            size="small"
                            effect="light"
                          >
                            <i :class="getPermissionLevelIcon(item.value)" class="me-1"></i>
                            {{ item.description }}
                          </el-tag>
                        </div>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <!-- 密码设置 -->
              <div class="row mb-4">
                <div class="col-12">
                  <h6 class="text-primary mb-3">
                    <i class="ri-lock-line me-2"></i>
                    {{ $t("admin.add.passwordSettings") }}
                  </h6>
                </div>
              </div>

              <div class="row">
                <!-- 密码 -->
                <div class="col-md-6 mb-3">
                  <el-form-item 
                    :label="$t('admin.add.password')" 
                    prop="userpassword"
                    :rules="isEdit ? [{ min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }] : [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }]"
                  >
                    <el-input
                      v-model="userpassword"
                      :placeholder="isEdit ? $t('admin.add.passwordPlaceholder') : $t('admin.add.password')"
                      prefix-icon="ri-lock-line"
                      show-password
                      clearable
                    />
                    <small v-if="isEdit" class="text-muted">
                      {{ $t("admin.add.passwordTip") }}
                    </small>
                  </el-form-item>
                </div>

                <!-- 确认密码 -->
                <div class="col-md-6 mb-3">
                  <el-form-item 
                    :label="$t('admin.add.reinputpassword')" 
                    prop="reinputuserpassword"
                    :rules="userpassword ? formRules.reinputuserpassword : []"
                  >
                    <el-input
                      v-model="reinputuserpassword"
                      :placeholder="$t('admin.add.reinputpassword')"
                      prefix-icon="ri-lock-unlock-line"
                      show-password
                      clearable
                    />
                  </el-form-item>
                </div>
              </div>

              <!-- 操作按钮 -->
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-end gap-2">
                    <el-button 
                      @click="$router.push('/admin/list')"
                      size="large"
                    >
                      <i class="ri-arrow-left-line me-1"></i>
                      {{ $t("global.button.back") }}
                    </el-button>
                    <el-button 
                      type="primary" 
                      @click="saveAdmin"
                      size="large"
                      :loading="loading"
                    >
                      <i class="ri-save-line me-1"></i>
                      {{ isEdit ? $t("admin.edit.save") : $t("admin.add.save") }}
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form>
          </div>

          <!-- 成功页面 -->
          <div v-else class="text-center p-4">
            <el-result icon="success" :title="$t('global.success')">
              <template slot="subTitle">
                {{ isEdit ? $t("admin.edit.successMessage") : $t("admin.add.successMessage") }}
              </template>
              <template slot="extra">
                <el-button 
                  type="primary" 
                  @click="$router.push('/admin/list')"
                  size="large"
                >
                  <i class="ri-list-check me-1"></i>
                  {{ $t("admin.add.backToList") }}
                </el-button>
              </template>
            </el-result>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* 卡片样式 */
.card {
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border-radius: 0.5rem;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 0.5rem 0.5rem 0 0 !important;
  border: none;
}

.card-header h5 {
  color: white;
  font-weight: 600;
}

/* 表单样式 */
.admin-form {
  padding: 1rem 0;
}

.admin-form .el-form-item {
  margin-bottom: 1.5rem;
}

.admin-form .el-form-item__label {
  font-weight: 500;
  color: #495057;
}

/* 分组标题样式 */
.text-primary {
  color: #667eea !important;
  font-weight: 600;
  font-size: 1rem;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 0.5rem;
}

/* 输入框样式 */
.el-input__inner {
  border-radius: 0.375rem;
  border: 1px solid #ced4da;
  transition: all 0.15s ease-in-out;
}

.el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

/* 选择器样式 */
.el-select {
  width: 100%;
}

.el-select .el-input__inner {
  border-radius: 0.375rem;
}

/* 按钮样式 */
.el-button {
  border-radius: 0.375rem;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
}

.el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* 权限标签样式 */
.el-tag {
  border-radius: 0.375rem;
  font-weight: 500;
}

.el-tag--danger {
  background-color: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.el-tag--primary {
  background-color: #eff6ff;
  border-color: #bfdbfe;
  color: #2563eb;
}

.el-tag--warning {
  background-color: #fffbeb;
  border-color: #fed7aa;
  color: #d97706;
}

.el-tag--info {
  background-color: #f0f9ff;
  border-color: #bae6fd;
  color: #0284c7;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-form .el-form-item__label {
    width: 100% !important;
    text-align: left !important;
    margin-bottom: 0.5rem;
  }
  
  .admin-form .el-form-item__content {
    margin-left: 0 !important;
  }
  
  .card-header .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .card-header .text-muted {
    margin-top: 0.5rem;
  }
}

/* 加载状态样式 */
.el-loading-mask {
  border-radius: 0.5rem;
}

/* 成功页面样式 */
.el-result {
  padding: 2rem 0;
}

.el-result__title {
  color: #28a745;
  font-weight: 600;
}

/* 表单验证样式 */
.el-form-item.is-error .el-input__inner {
  border-color: #dc3545;
}

.el-form-item__error {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

/* 图标样式 */
.ri-user-add-line,
.ri-user-line,
.ri-shield-user-line,
.ri-lock-line {
  font-size: 1.1rem;
}

/* 间距优化 */
.gap-2 {
  gap: 0.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}
</style>